export interface MangaChapter {
  id: string;
  title: string;
  number: number;
  updateDate: string;
}

export interface MangaItem {
  id: string;
  title: string;
  author: string;
  category: string;
  tags: string[];
  description: string;
  coverImage: string;
  rating: number;
  views: string;
  status: '连载中' | '已完结';
  latestChapter: MangaChapter;
  chapters: MangaChapter[];
}

export const featuredManga: MangaItem = {
  id: 'shuumatsu-no-valkyrie',
  title: '终末的女武神',
  author: '梅村真也 / アジチカ / フクイタクミ',
  category: '热血',
  tags: ['战斗', '神话', '历史', '热血', '奇幻'],
  description: '众神与人类的最终决战！为了决定人类未来的命运，北欧众神召开了一千年一度的"人类存亡会议"。众神一致认为人类已经无可救药，应当将其灭绝。然而，半人半神的女武神布伦希尔德提出了反对意见，她主张给予人类最后的机会——由13位人类代表与13位神明进行一对一的对决，也就是"诸神黄昏"。人类能否在女武神的帮助下战胜神明，赢得继续生存的权利？',
  coverImage: 'https://readdy.ai/api/search-image?query=Epic%20manga%20cover%20art%20style%2C%20powerful%20female%20Valkyrie%20warrior%20with%20flowing%20hair%20in%20dramatic%20battle%20pose%2C%20warm%20crimson%20and%20gold%20color%20scheme%2C%20Japanese%20comic%20illustration%20with%20dynamic%20action%20lines%2C%20dark%20atmospheric%20background%20with%20glowing%20accents%2C%20stylized%20anime%20art%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20professional%20manga%20cover%20quality&width=800&height=1120&seq=manga-cover-valkyrie&orientation=portrait',
  rating: 9.6,
  views: '1280万',
  status: '连载中',
  latestChapter: {
    id: 'ch-89',
    title: '第89话：最后的决意',
    number: 89,
    updateDate: '2026-07-01',
  },
  chapters: Array.from({ length: 89 }, (_, i) => ({
    id: `ch-${89 - i}`,
    title: `第${89 - i}话`,
    number: 89 - i,
    updateDate: `2026-${String(6 - Math.floor(i / 15)).padStart(2, '0')}-${String(30 - (i % 15) * 2).padStart(2, '0')}`,
  })),
};

export const popularMangaList: MangaItem[] = [
  {
    id: 'one-piece',
    title: '海贼王',
    author: '尾田荣一郎',
    category: '热血',
    tags: ['冒险', '友情', '热血', '海盗'],
    description: '路飞与伙伴们在大海贼时代的冒险故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Manga%20cover%20art%20style%2C%20young%20pirate%20boy%20with%20straw%20hat%20smiling%20confidently%2C%20warm%20vibrant%20colors%2C%20ocean%20adventure%20theme%2C%20Japanese%20comic%20illustration%2C%20clean%20simple%20background%20with%20soft%20gradient%2C%20professional%20manga%20cover&width=800&height=1120&seq=manga-cover-onepiece&orientation=portrait',
    rating: 9.7,
    views: '3560万',
    status: '连载中',
    latestChapter: { id: 'op-1120', title: '第1120话', number: 1120, updateDate: '2026-07-02' },
    chapters: [],
  },
  {
    id: 'jujutsu-kaisen',
    title: '咒术回战',
    author: '芥见下下',
    category: '热血',
    tags: ['战斗', '咒术', '校园', '黑暗'],
    description: '虎杖悠仁吞下咒物手指后，卷入咒术世界的战斗。',
    coverImage: 'https://readdy.ai/api/search-image?query=Manga%20cover%20art%20style%2C%20young%20male%20sorcerer%20with%20dark%20spiky%20hair%20in%20dynamic%20battle%20stance%2C%20dark%20atmospheric%20background%20with%20purple%20and%20crimson%20energy%20effects%2C%20Japanese%20comic%20illustration%2C%20professional%20manga%20cover%20quality&width=800&height=1120&seq=manga-cover-jjk&orientation=portrait',
    rating: 9.4,
    views: '2150万',
    status: '连载中',
    latestChapter: { id: 'jjk-268', title: '第268话', number: 268, updateDate: '2026-07-01' },
    chapters: [],
  },
  {
    id: 'demon-slayer',
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    category: '热血',
    tags: ['战斗', '鬼怪', '历史', '兄妹'],
    description: '灶门炭治郎为救妹妹踏上斩鬼之旅。',
    coverImage: 'https://readdy.ai/api/search-image?query=Manga%20cover%20art%20style%2C%20young%20swordsman%20with%20checkered%20green%20and%20black%20haori%20coat%20wielding%20katana%2C%20dramatic%20water%20breathing%20effect%2C%20dark%20night%20background%20with%20crescent%20moon%2C%20Japanese%20comic%20illustration%2C%20professional%20manga%20cover&width=800&height=1120&seq=manga-cover-demonslayer&orientation=portrait',
    rating: 9.5,
    views: '2890万',
    status: '已完结',
    latestChapter: { id: 'ds-205', title: '第205话（完）', number: 205, updateDate: '2025-12-20' },
    chapters: [],
  },
  {
    id: 'attack-on-titan',
    title: '进击的巨人',
    author: '谏山创',
    category: '热血',
    tags: ['战斗', '末日', '政治', '悬疑'],
    description: '人类为对抗巨人而在围墙中生存的故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Manga%20cover%20art%20style%2C%20soldier%20with%20vertical%20maneuvering%20gear%20fighting%20giant%20titan%2C%20apocalyptic%20atmosphere%2C%20warm%20sepia%20and%20crimson%20tones%2C%20Japanese%20comic%20illustration%2C%20professional%20manga%20cover%20quality&width=800&height=1120&seq=manga-cover-aot&orientation=portrait',
    rating: 9.3,
    views: '3120万',
    status: '已完结',
    latestChapter: { id: 'aot-139', title: '第139话（完）', number: 139, updateDate: '2025-06-10' },
    chapters: [],
  },
  {
    id: 'chainsaw-man',
    title: '电锯人',
    author: '藤本树',
    category: '热血',
    tags: ['战斗', '恶魔', '黑暗', '都市'],
    description: '少年电次与电锯恶魔融合后的黑暗战斗物语。',
    coverImage: 'https://readdy.ai/api/search-image?query=Manga%20cover%20art%20style%2C%20young%20man%20with%20chainsaw%20arms%20and%20head%20in%20dynamic%20pose%2C%20urban%20night%20background%20with%20neon%20lights%2C%20dark%20and%20gritty%20aesthetic%2C%20Japanese%20comic%20illustration%2C%20professional%20manga%20cover&width=800&height=1120&seq=manga-cover-chainsaw&orientation=portrait',
    rating: 9.2,
    views: '1680万',
    status: '连载中',
    latestChapter: { id: 'csm-178', title: '第178话', number: 178, updateDate: '2026-07-02' },
    chapters: [],
  },
  {
    id: 'spy-family',
    title: '间谍过家家',
    author: '远藤达哉',
    category: '搞笑',
    tags: ['间谍', '家庭', '喜剧', '温馨'],
    description: '间谍、杀手与超能力少女组成的虚假家庭喜剧。',
    coverImage: 'https://readdy.ai/api/search-image?query=Manga%20cover%20art%20style%2C%20elegant%20family%20of%20three%20with%20father%20in%20suit%20mother%20in%20dress%20and%20cute%20little%20girl%2C%20warm%20and%20cozy%20color%20palette%2C%20Japanese%20comic%20illustration%2C%20professional%20manga%20cover%20quality&width=800&height=1120&seq=manga-cover-spyfamily&orientation=portrait',
    rating: 9.4,
    views: '1950万',
    status: '连载中',
    latestChapter: { id: 'sf-102', title: '第102话', number: 102, updateDate: '2026-06-30' },
    chapters: [],
  },
];

export const categories = [
  { id: 'all', name: '全部', icon: 'ri-apps-line' },
  { id: 'hot-blood', name: '热血', icon: 'ri-fire-line' },
  { id: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { id: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { id: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { id: 'sci-fi', name: '科幻', icon: 'ri-rocket-line' },
  { id: 'horror', name: '恐怖', icon: 'ri-ghost-line' },
  { id: 'slice-of-life', name: '日常', icon: 'ri-sun-line' },
  { id: 'sports', name: '运动', icon: 'ri-basketball-line' },
  { id: 'mystery', name: '悬疑', icon: 'ri-search-eye-line' },
];

export const reviews = [
  {
    id: 'r1',
    name: '漫画迷小王',
    username: '@xiaowang_manga',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20boy%20avatar%20with%20warm%20smile%2C%20simple%20round%20profile%20picture%2C%20clean%20background&width=100&height=100&seq=avatar-user-01&orientation=squarish',
    comment: '古古漫画网的加载速度真的太快了，界面也很干净。追更终末的女武神每次都是第一时间更新，比其他平台快多了！',
    date: '2026-06-28',
  },
  {
    id: 'r2',
    name: '二次元阿琳',
    username: '@alin_2d',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20pink%20hair%2C%20simple%20round%20profile%20picture%2C%20clean%20background&width=100&height=100&seq=avatar-user-02&orientation=squarish',
    comment: '用了很多漫画网站，古古是体验最好的。没有烦人的弹窗广告，阅读体验流畅，漫画资源也很全。',
    date: '2026-06-25',
  },
  {
    id: 'r3',
    name: '战斗漫狂热者',
    username: '@battle_fan',
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20young%20man%20avatar%20with%20determined%20expression%2C%20simple%20round%20profile%20picture%2C%20clean%20background&width=100&height=100&seq=avatar-user-03&orientation=squarish',
    comment: '终末的女武神每一话都看得热血沸腾！古古的评论区氛围也很好，大家讨论剧情都很认真，不像其他地方全是刷屏。',
    date: '2026-06-22',
  },
  {
    id: 'r4',
    name: '深夜追漫人',
    username: '@night_reader',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20girl%20avatar%20with%20glasses%20and%20dark%20hair%2C%20simple%20round%20profile%20picture%2C%20clean%20background&width=100&height=100&seq=avatar-user-04&orientation=squarish',
    comment: '每天晚上睡前必备的漫画站，页面简洁配色舒服，长时间看也不会累眼睛。推荐给了好几个朋友了！',
    date: '2026-06-20',
  },
  {
    id: 'r5',
    name: '神话爱好者',
    username: '@myth_lover',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20scholarly%20man%20avatar%20with%20calm%20smile%2C%20simple%20round%20profile%20picture%2C%20clean%20background&width=100&height=100&seq=avatar-user-05&orientation=squarish',
    comment: '终末的女武神把各国神话和历史人物融合得太好了，始皇帝对哈迪斯那场简直封神！感谢古古提供这么好的阅读平台。',
    date: '2026-06-18',
  },
  {
    id: 'r6',
    name: '日漫老司机',
    username: '@jp_manga_vet',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20middle%20aged%20man%20avatar%20with%20gentle%20expression%2C%20simple%20round%20profile%20picture%2C%20clean%20background&width=100&height=100&seq=avatar-user-06&orientation=squarish',
    comment: '从学生时代就开始看漫画，古古漫画网是我用过最舒服的平台之一。更新及时，翻译质量高，强烈推荐！',
    date: '2026-06-15',
  },
];

export const aboutFeatures = [
  { id: 'f1', icon: 'ri-flashlight-line', label: '极速加载' },
  { id: 'f2', icon: 'ri-smartphone-line', label: '多端适配' },
  { id: 'f3', icon: 'ri-shield-check-line', label: '正版体验' },
  { id: 'f4', icon: 'ri-user-heart-line', label: '用户至上' },
  { id: 'f5', icon: 'ri-global-line', label: '海量资源' },
];